<template>
    <div class="x-md" v-if="aItems.length > 0">
        <h2>学校资质</h2>
        <div class="layui-row">
            <div class="item layui-col-xs3 layui-col-sm2 layui-col-lg2" v-for="(item, index) in aItems" :key="index">
                <a href="javascript:">
                    <img :title="item.attributes.desc" :src="myUtils.getUrlPic(item.attributes.logo.data,'small')" />
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    data: Object
})
const aItems = ref([]);
aItems.value = props.data.data.attributes.school_certifications.data;

</script>

<style scoped>

</style>